import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";
export const Campaign: FC<IconProps> = ({
  color = defaultColor,
  height = 24,
}) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.62785 9.93962L5.83659 11.7326C5.83659 11.7326 9.05435 18.3832 10.9868 22.3968C11.488 23.4354 12.7415 23.8722 13.7902 23.3808C14.8384 22.8843 15.2793 21.6424 14.7833 20.6034C12.8456 16.5902 9.62785 9.93962 9.62785 9.93962Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.6496 12.2278C23.3238 13.6276 22.0407 15.1812 20.5016 14.9711C17.5678 14.5707 14.9454 14.8553 11.8361 16.3248C9.34265 17.5057 8.78166 17.7564 6.72555 18.7261C4.89352 19.5923 2.69301 18.8231 1.8186 17.0079C1.81825 17.0028 1.81267 16.9979 1.81232 16.9927C0.937907 15.1776 1.71423 12.9975 3.54626 12.1312C5.59714 11.1619 6.16301 10.9057 8.65683 9.72992C11.7741 8.26202 13.6492 6.41983 15.1811 3.90215C15.9851 2.5809 17.9913 2.55549 18.6631 3.95039L22.6496 12.2278Z"
      fill={color}
    />
  </svg>
);
